<script>
import RadioChoice from '@/components/RadioChoice.vue';
import TextContent from '@/components/TextContent.vue';

export default {
  name: 'SingleTextareaFilter',
  components: {
    TextContent,
    RadioChoice,
  },
  props: ['caption', 'value'],
  data() {
    return {
      selected: {
        color: 'White',
        items: [],
      },
      typeOptions: [
        {
          title: 'Whitelist',
          name: 'White',
        },
        {
          title: 'Blacklist',
          name: 'Black',
        },
      ],
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selected = val;
      },
    },
    selected: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    filterList(list) {
      return (list || []).filter(v => v.length > 0);
    },
  },
};
</script>

<template>
  <div>
    <div class="create-feed-form--textarea-heading mb-10">{{ caption }} ({{ filterList(selected.items).length }})</div>
    <div class="create-feed-form--textarea-row mb-10">
      <div class="input-block">
        <text-content v-model="selected.items" :transform="(v) => v.toUpperCase()" />
      </div>
    </div>
    <RadioChoice class="mb-25" title="" :group="caption" :items="typeOptions" v-model="selected.color" @change="(v) => this.selected.color = v" />
  </div>
</template>
